export const GAevent = function (data: { category?: string; action?: string; label?: string, form?: string }) {
    if(!window.dataLayer || typeof window === 'undefined') return;
    (dataLayer = window.dataLayer || []).push({
        'eCategory': data.category,
        'eAction': data.action,
        'eLabel': data.label,
        'eForm': data.form || undefined,
        'event': 'GAEvent'
    });
  };

export type ApplicationMetrikaGoal =
    | 'Application_Online_Doctor'
    | 'Application_Offline_Clinic'
    | 'Application_Online_Clinic'
    | 'Application_Visit';

/** Цели разметки «Выезд на дом» (type = visit). */
export const VISIT_METRIKA_GOAL_OPEN_FORM = 'Visit_Open_Form';
export const VISIT_METRIKA_GOAL_PAYMENT = 'Visit_Payment';
export const LANDING_VISIT_METRIKA_PREFIX = '/vyzov-veterinara-na-dom';

export type MetrikaParams = Record<string, unknown>;

export function isLandingVisitMetrikaPath(path: string): boolean {
    return path === LANDING_VISIT_METRIKA_PREFIX
        || path === `${LANDING_VISIT_METRIKA_PREFIX}/`
        || path.startsWith(`${LANDING_VISIT_METRIKA_PREFIX}/`);
}

export function reachMetrikaGoal(
    counterId: string | number,
    goalName: string,
    params?: MetrikaParams,
) {
    try {
        if (params) {
            window.ym?.(counterId, 'reachGoal', goalName, params);
        } else {
            window.ym?.(counterId, 'reachGoal', goalName);
        }
    } catch {
    }
}

/** Ждёт появления window.ym (скрипт Метрики из useHead) и затем шлёт цель. */
export function reachMetrikaGoalWhenReady(
    counterId: string | number,
    goalName: string,
    params?: MetrikaParams,
    maxWaitMs = 5000,
) {
    if (typeof window === 'undefined') {
        return;
    }

    const send = () => reachMetrikaGoal(counterId, goalName, params);

    if (typeof window.ym === 'function') {
        send();
        return;
    }

    const started = Date.now();
    const timer = setInterval(() => {
        if (typeof window === 'undefined') {
            clearInterval(timer);
            return;
        }

        const ready = typeof window.ym === 'function';
        const timedOut = Date.now() - started >= maxWaitMs;

        if (ready || timedOut) {
            clearInterval(timer);
            if (ready) {
                send();
            }
        }
    }, 50);
}

export function setMetrikaParamsWhenReady(
    counterId: string | number,
    params: MetrikaParams,
    maxWaitMs = 5000,
) {
    if (typeof window === 'undefined') {
        return;
    }

    const send = () => {
        try {
            window.ym?.(counterId, 'params', params);
        } catch {
        }
    };

    if (typeof window.ym === 'function') {
        send();
        return;
    }

    const started = Date.now();
    const timer = setInterval(() => {
        const ready = typeof window.ym === 'function';
        const timedOut = Date.now() - started >= maxWaitMs;

        if (ready || timedOut) {
            clearInterval(timer);
            if (ready) {
                send();
            }
        }
    }, 50);
}

export function resolveApplicationGoalFromBookData(bookData: {
    type: 'online' | 'offline' | 'service' | 'visit';
    clinicId?: number;
    serviceId?: number;
} | null): ApplicationMetrikaGoal | null {
    if (!bookData) {
        return null;
    }
    if (bookData.type === 'visit') {
        return 'Application_Visit';
    }
    if (bookData.type === 'service' || bookData.serviceId) {
        return bookData.clinicId
            ? 'Application_Offline_Clinic'
            : 'Application_Online_Clinic';
    }
    if (bookData.type === 'offline') {
        return 'Application_Offline_Clinic';
    }
    return bookData.clinicId ? 'Application_Online_Clinic' : 'Application_Online_Doctor';
}

export function resolveApplicationGoalFromFormAppointment(props: {
    clinicId?: number;
    isOnlineRequest?: boolean;
    clinic?: string;
    isVisit?: boolean;
}): ApplicationMetrikaGoal {
    if (props.isVisit) {
        return 'Application_Visit';
    }
    if (props.clinicId) {
        return 'Application_Offline_Clinic';
    }
    if (props.isOnlineRequest && props.clinic) {
        return 'Application_Online_Clinic';
    }
    if (props.isOnlineRequest && !props.clinic) {
        return 'Application_Online_Doctor';
    }
    return 'Application_Offline_Clinic';
}
